export const FEATURES = {
    paymentOptions: true,
};
